import ReactHtmlParser from "react-html-parser";

export default (sopParameters) => ReactHtmlParser(
  `
  <div>
    <h1>IN_QC_LATE_PICKUP</h1>

    <div>
      <h3>***RESOLUTION SOP FOR IN_QC_LATE_PICKUP***</h3>
      
      <ol>
        <li>LM POC checks cortex</li>
        <li>Check if DP is within site premises.
          <ul>
            <li>Yes → LM POC will call DP</li>
            <li>No → Order reassign</li>
          </ul>
        </li>
        <li>If LM POC calls DP, check if DP answers call.
          <ul>
            <li>Yes → Check if DP is ready to pickup</li>
            <li>No → Order reassign</li>
          </ul>
        </li>
        <li>If DP is ready to pickup:
          <ul>
            <li>LM POC collects reason for delay</li>
            <li>Order picked up</li>
            <li>Exception resolved with delay reason</li>
          </ul>
        </li>
        <li>If order is reassigned:
          <ul>
            <li>DP discharge (Assuming we will have discharge enabled for this use case in future)</li>
          </ul>
        </li>
      </ol>

      <p>For more details, please visit: <a href="https://w.amazon.com/bin/view/Stratos/Internal/MBEDashboard/ExceptionSOP/IN_QC_LATE_PICKUP/">IN_QC_LATE_PICKUP Wiki</a></p>
    </div>


  </div>
`
);



// WEBPACK FOOTER //
// ./src/components/taskExecution/TaskSOP/FallbackSOPWiki/IN_QC_LATE_PICKUP.jsx